import { useAuth } from "../../context/authContext";

const softColors = [
  { bg: "#E3F2FD", text: "#1E88E5" },
  { bg: "#E8F5E9", text: "#43A047" },
  { bg: "#FFF3E0", text: "#FB8C00" },
  { bg: "#F3E5F5", text: "#8E24AA" },
  { bg: "#E0F7FA", text: "#00ACC1" },
  { bg: "#FCE4EC", text: "#D81B60" },
  { bg: "#F9FBE7", text: "#9E9D24" },
  { bg: "#FBE9E7", text: "#E64A19" },
  { bg: "#F1F8E9", text: "#558B2F" },
  { bg: "#EDE7F6", text: "#5E35B1" },
  { bg: "#E0F2F1", text: "#00796B" },
  { bg: "#FFF8E1", text: "#FBC02D" },
  { bg: "#F3F3F3", text: "#616161" },
  { bg: "#E1F5FE", text: "#039BE5" },
  { bg: "#FFEBEE", text: "#E53935" },
  { bg: "#EDEDED", text: "#424242" },
];

const UserAvatar = ({ className, previewUrl }) => {
  const size = 100;
  const { user } = useAuth();
  const first = user?.first_name || "";
  const last = user?.last_name || "";
  const initials =
    (first?.[0] || "").toUpperCase() + (last?.[0] || "").toUpperCase();

  // Fallback if no name at all
  const safeChar1 = first.charCodeAt(0) || 0;
  const safeChar2 = last.charCodeAt(0) || 0;
  const index = (safeChar1 + safeChar2) % softColors.length;

  const color = softColors[index] || softColors[0];

  return previewUrl || user?.profile_image ? (
    <img
      src={previewUrl || user.profile_image}
      alt="Avatar"
      className={`rounded-full object-cover ${className}`}
      style={{ width: size, height: size }}
    />
  ) : (
    <div
      className={`rounded-full flex items-center justify-center font-semibold ${className}`}
      style={{
        backgroundColor: color.bg,
        color: color.text,
        width: size,
        height: size,
        fontSize: size * 0.35,
      }}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
